module.exports = __webpack_public_path__ + "static/media/cheltenham-normal-400.a2d9a0d1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/cheltenham-normal-400.woff
// module id = 279
// module chunks = 0